import { createSlice } from '@reduxjs/toolkit';
import { ApiPaginationResponse } from 'src/components/ui/Table/Table.interface';
import { logout } from 'src/store/actions/authActions';
import {
  setMapFilter,
  setPriorityTickets,
  setTicketDetails,
  setTicketList,
  setTicketNotes,
  setTicketStatistics,
  TICKET_SLICE,
} from 'src/store/actions/ticketActions';
import {
  ListTicket,
  MapFilter,
  Ticket,
  TicketNote,
  TicketStatistics,
  TicketStatus,
} from 'src/store/models/Ticket';

import {
  localStorageHelper,
  sessionStorageHelper,
  StoragePrefix,
} from '../utils/localStorage';

export interface TicketState {
  mapFilter: MapFilter;
  ticketList: ApiPaginationResponse<ListTicket[], TicketStatus>;
  priorityTickets: ListTicket[];
  ticketDetails: Ticket;
  ticketNotes: TicketNote[];
  statistics: {
    [key in TicketStatus]: TicketStatistics;
  };
}

const initialMapFilter = {
  [TicketStatus.TO_DO]: true,
  [TicketStatus.IN_PROGRESS]: true,
  [TicketStatus.RESOLVED]: true,
  [TicketStatus.UNASSIGNED]: true,
};

const storageHelper = localStorageHelper?.get(StoragePrefix.REMEMBER_ME)
  ? localStorageHelper
  : sessionStorageHelper;

const initialState: TicketState = {
  mapFilter: storageHelper?.get(StoragePrefix.MAP_FILTER) || initialMapFilter,
  ticketList: {
    data: [],
    count: 0,
    ctx: null,
  },
  priorityTickets: [],
  ticketDetails: null,
  ticketNotes: [],
  statistics: {
    [TicketStatus.UNASSIGNED]: null,
    [TicketStatus.TO_DO]: null,
    [TicketStatus.IN_PROGRESS]: null,
    [TicketStatus.RESOLVED]: null,
  },
};

const ticketSlice = createSlice({
  name: TICKET_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setMapFilter, (state, action) => {
        state.mapFilter = action.payload;
      })
      .addCase(logout, (state) => {
        state.mapFilter = initialMapFilter;
      })
      .addCase(setTicketList, (state, action) => {
        state.ticketList = action.payload;
      })
      .addCase(setPriorityTickets, (state, action) => {
        state.priorityTickets = action.payload;
      })
      .addCase(setTicketDetails, (state, action) => {
        state.ticketDetails = action.payload;
      })
      .addCase(setTicketNotes, (state, action) => {
        state.ticketNotes = action.payload;
      })
      .addCase(setTicketStatistics, (state, action) => {
        state.statistics[action.payload.status] = action.payload.stats;
      });
  },
});

export default ticketSlice.reducer;
